// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0fe240b1","189":"4daf4a80","247":"625c7929","625":"a896c38e","627":"68aefe88","653":"66f82ab2","738":"5dd2aefe","768":"ae26d794","834":"227dc4d6","923":"b1604e17","932":"bc016fee","938":"caaa43f4"}[chunkId] + ".chunk.js";
};